import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Tooltip from 'rc-tooltip';

// app modules: components
import Image from 'components/Image';
import Heading from 'components/Heading';
import { ListItem, UnorderedList } from 'components/List';

// app modules: services
import assets from 'services/assets';

// assets
import CssBookAwards from './BookAwards.scss';

class BookAwards extends Component {
  static propTypes = {
    awards: PropTypes.arrayOf(
      PropTypes.shape({
        result: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
  };

  static defaultProps = {
    awards: [
      {
        result: '',
        name: '',
      },
    ],
  };

  renderAwards() {
    const { awards } = this.props;
    if (awards !== null && awards.length > 0) {
      return awards.filter(award => award.image).map(award => {
        const awardTooltip = (
          <div className="book-awards__tooltip">{`${award.name} - ${award.result}`}</div>
        );

        return (
          <Tooltip
            overlay={awardTooltip}
            placement="top"
            mouseEnterDelay={0.3}
            key={`${award.name}-${award.sortingOption}`}
          >
            <ListItem className="book-awards__item">
              <a href={award.awardUrl} rel="noopener noreferrer" target="_blank" alt="award page">
                <Image
                  image={assets.awardUrl(award.image, {
                    resize: 'fit-in',
                    width: 100,
                    height: 100,
                  })}
                  height={100}
                  shape="circle"
                />
              </a>
            </ListItem>
          </Tooltip>
        );
      });
    }
    return null;
  }

  render() {
    const awards = this.renderAwards();

    if (awards.length) {
      return (
        <div className="book-awards">
          <Heading withDash className="margin-bottom-20">
            awards
          </Heading>
          <UnorderedList className="book-awards__list" inline spaceBetween="none">
            {awards}
          </UnorderedList>
        </div>
      );
    }
    return null;
  }
}

export default withStyles(CssBookAwards)(BookAwards);
